import { RootState } from '../store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { produce } from 'immer';

export interface TSaveINT {
    scene: string,
    image: string,
    date: number,
    title: string

}
export interface TSavesINT {
    saves: TSaveINT[]
}
export interface TGetSave {
    index: number
}

const savesSlice = createSlice({
    name: 'saves',
    initialState: { saves: [] } as TSavesINT,
    reducers: {
        setSave: (state, { payload }: PayloadAction<TSaveINT>) => {

            return produce(state, draft => {
                draft.saves.push(payload);
            });
        },
    },

});

export const { setSave } = savesSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectSaves = (state: RootState) => state.saves;


export default savesSlice.reducer;
